define( [
	"../Data"
], function( Data ) {
	"use strict";

	return new Data();
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/data/var/dataPriv.js
// module id = 5
// module chunks = 0